import type Flicking from '@egjs/flicking'
import { EVENTS, type Plugin } from '@egjs/flicking'

/**
 * Custom plugin to fade out slides that are not currently visible.
 */
class Fade implements Plugin {
  private _flicking: Flicking | null = null

  public init(flicking: Flicking): void {
    if (this._flicking) {
      this.destroy()
    }

    this._flicking = flicking
    flicking.on(EVENTS.MOVE, this._onMove)
    flicking.on(EVENTS.AFTER_RESIZE, this.update)
    this._onMove()
  }

  public destroy(): void {
    if (!this._flicking) return

    this._flicking.off(EVENTS.MOVE, this._onMove)
    this._flicking.off(EVENTS.AFTER_RESIZE, this.update)
    this._flicking.panels.forEach((v) => {
      // Reset the set opacity.
      v.element.style.opacity = ''
    })
    this._flicking = null
  }

  public update = (): void => {
    this._onMove()
  }

  private _onMove = (): void => {
    const flicking = this._flicking
    if (!flicking) return

    const visibleSlides = flicking.panelsPerView - 1

    flicking.panels.forEach((panel) => {
      const el = panel.element
      const progress = panel.progress
      const opacity =
        progress >= 0 && progress <= visibleSlides
          ? 1
          : Math.max(
              0.3,
              1 - Math.abs(progress < 0 ? progress : progress - visibleSlides),
            )
      el.style.opacity = `${opacity}`
    })
  }
}

export default Fade
